import { render, staticRenderFns } from "./turnover-list.vue?vue&type=template&id=a62d2f7e&scoped=true&"
import script from "./turnover-list.vue?vue&type=script&lang=js&"
export * from "./turnover-list.vue?vue&type=script&lang=js&"
import style0 from "./turnover-list.vue?vue&type=style&index=0&id=a62d2f7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62d2f7e",
  null
  
)

export default component.exports